module.exports = __webpack_public_path__ + "static/img/logo.1dba03d.png";